import { render, staticRenderFns } from "./scanPackage.vue?vue&type=template&id=58956075&scoped=true"
import script from "./scanPackage.vue?vue&type=script&lang=js"
export * from "./scanPackage.vue?vue&type=script&lang=js"
import style0 from "./scanPackage.vue?vue&type=style&index=0&id=58956075&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58956075",
  null
  
)

export default component.exports